import React, {useState, useContext} from 'react';
import axios from 'axios';
import Qs from 'qs';
import {
  Grid,
  Snackbar,
  Typography,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import {useTranslation} from 'react-i18next';

import Conf from 'utils/Conf';
import Context from 'utils/Context';
import './NewsletterSubscriptionForm.scss';

const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const NewsletterSubscriptionForm = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState(null);
  const [hasBeenSent, setHasBeenSent] = useState(false);
  const {appState} = useContext(Context);
  const {t} = useTranslation();

  const shouldShowNewsletterCheckbox = appState.conf.NEWSLETTER_ENABLED;


  const handleSubmit = e => {
    e.preventDefault();
    setHasBeenSent(false);
    if (EMAIL_REGEX.test(email)) {
      axios.post(`${Conf.apiBaseUriLegacy}/formulaire`, Qs.stringify({email}), {withCredentials: false}).then(() => {
        setEmail('');
        setHasBeenSent(true);
      }).catch((err) => {
        setError('newsletter-error');
      });
    }
  };

  if (!shouldShowNewsletterCheckbox) return null;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="body1" component="p" className="blanc">
          {t('inscrivez-vous-a-notre-newsletter-pour-decouvrir-nos-actualites-en-avant-premiere')}
        </Typography>
        <form onSubmit={handleSubmit} className="newsletter-form form">
          <input
            className="newsletter-form input"
            type="email"
            placeholder={t('votre-email')}
            onChange={e => setEmail(e.target.value)}
            value={email}
          />
          <button type="submit" className="newsletter-form button">
            {t('inscription')}
          </button>
        </form>
      </Grid>
      <Snackbar open={hasBeenSent} autoHideDuration={6000} onClose={() => setHasBeenSent(false)}>
        <Alert elevation={6} variant="filled" onClose={() => setHasBeenSent(false)} severity="success">
          {t('inscription-validee')}
        </Alert>
      </Snackbar>
      <Snackbar open={!!error} autoHideDuration={6000} onClose={() => setError(null)}>
        <Alert elevation={6} variant="filled" onClose={() => setError(null)} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default NewsletterSubscriptionForm;
